import { LayoutType, withLayout } from 'hocs/with-layout';
import { ClipDetailGuest } from './clip-detail-guest';

const WrappedClipDetailGuest = withLayout(
  LayoutType.WithOldNavAndFooter,
  ClipDetailGuest,
);

export { WrappedClipDetailGuest as ClipDetailGuest };
